(function () {
  'use strict';

  function closeAllMob(wrap) {
    var col = wrap.querySelector('.eqb-mmob-l2-col');
    var l3col = wrap.querySelector('.eqb-mmob-l3-col');
    if (col) {
      col.classList.remove('has-active');
      col.querySelectorAll('.eqb-mmob-l2-item').forEach(function (it) { it.classList.remove('is-active'); });
      col.querySelectorAll('button.eqb-mmob-l2').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    if (l3col) {
      l3col.querySelectorAll('.eqb-mmob-l3').forEach(function (p) {
        p.classList.remove('is-open');
        p.style.marginTop = '';
      });
    }
  }

  function initMmobL2() {
    document.querySelectorAll('button.eqb-mmob-l2').forEach(function (btn) {
      if (btn.dataset.eqbL2Bound) return;
      btn.dataset.eqbL2Bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = btn.closest('.eqb-mmob-l2-item');
        var col = btn.closest('.eqb-mmob-l2-col');
        var wrap = btn.closest('.eqb-mmob-wrap');
        if (!item || !col || !wrap) return;
        var panelId = btn.getAttribute('data-l3');
        var panel = panelId ? document.getElementById(panelId) : null;
        var willOpen = !item.classList.contains('is-active');
        closeAllMob(wrap);
        if (willOpen && panel) {
          col.classList.add('has-active');
          item.classList.add('is-active');
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var offset = btn.getBoundingClientRect().top - col.getBoundingClientRect().top;
          panel.style.marginTop = offset + 'px';
        }
      });
    });
  }

  function initMmobL1() {
    document.querySelectorAll('.eqb-mmob-menu').forEach(function (menu) {
      if (menu.dataset.eqbMobBound) return;
      menu.dataset.eqbMobBound = '1';

      menu.querySelectorAll('.drawer-top-menu > details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          var li = d.closest('.drawer-top-menu');
          if (d.open) {
            li.classList.add('eqb-l1-open');
          } else {
            li.classList.remove('eqb-l1-open');
            var wrap = d.querySelector('.eqb-mmob-wrap');
            if (wrap) closeAllMob(wrap);
          }
          menu.classList.toggle('has-open', !!menu.querySelector('.drawer-top-menu > details[open]'));
        });
      });
    });
  }

  function initPcMega() {
    document.querySelectorAll('.eqb-mega').forEach(function (mega) {
      if (mega.dataset.eqbBound) return;
      mega.dataset.eqbBound = '1';

      var list = mega.querySelector('.eqb-mega-l2-list');
      if (!list) return;
      var content = mega.closest('.mega-menu__content') || mega;

      function clearActive() {
        list.classList.remove('has-active');
        list.querySelectorAll('.eqb-l2-item').forEach(function (x) { x.classList.remove('is-active'); });
      }

      list.querySelectorAll('.eqb-l2-item.has-sub').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          list.classList.add('has-active');
          list.querySelectorAll('.eqb-l2-item').forEach(function (x) { x.classList.remove('is-active'); });
          item.classList.add('is-active');
        });
      });

      content.addEventListener('mouseleave', clearActive);
      var host = mega.closest('header-menu');
      if (host) {
        var details = host.querySelector('details');
        if (details) {
          details.addEventListener('toggle', function () { if (!details.open) clearActive(); });
        }
      }
    });
  }

  function initCartA11y() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    var region = document.getElementById('eqb-cart-live');
    if (!region || region.dataset.eqbBound) return;
    region.dataset.eqbBound = '1';
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      window.setTimeout(function () {
        var countEl = document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden');
        var countText = countEl ? countEl.textContent.trim() : '';
        var message = countText ? ('Added to cart. ' + countText) : 'Item added to cart.';
        region.textContent = '';
        window.setTimeout(function () { region.textContent = message; }, 80);
      }, 450);
    });
  }

  function initDrawerCol() {
    var tracks = document.querySelectorAll('[data-eqb-drawer-track]');
    tracks.forEach(function (track) {
      if (track.dataset.eqbBound) return;
      track.dataset.eqbBound = '1';
      var col = track.closest('.eqb-drawer-col');
      var bar = col ? col.querySelector('[data-eqb-drawer-bar]') : null;
      var thumb = bar ? bar.querySelector('.eqb-drawer-col-bar-thumb') : null;
      if (!bar || !thumb) return;

      function update() {
        var sw = track.scrollWidth;
        var cw = track.clientWidth;
        if (sw <= cw + 1) {
          bar.style.display = 'none';
          return;
        }
        bar.style.display = '';
        var ratio = cw / sw;
        var thumbW = Math.max(ratio * 100, 12);
        var pos = track.scrollLeft / (sw - cw);
        thumb.style.width = thumbW + '%';
        thumb.style.left = (pos * (100 - thumbW)) + '%';
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      var host = track.closest('.menu-drawer-container');
      if (host) host.addEventListener('toggle', function () { window.setTimeout(update, 50); });
      update();
    });
  }

  var megaCloseTimer = null;
  var megaSwitchTimer = null;
  var pcQuery = window.matchMedia('(min-width: 990px)');

  function clearMegaTimers() {
    clearTimeout(megaCloseTimer);
    clearTimeout(megaSwitchTimer);
  }

  function fitMega(d) {
    var c = d.querySelector('.mega-menu__content');
    if (!c) return;
    var header = d.closest('.header-wrapper') || d.closest('header');
    var bottom = header ? header.getBoundingClientRect().bottom : 0;
    c.style.maxHeight = Math.max(240, Math.floor(window.innerHeight - bottom - 16)) + 'px';
  }

  function closeMega(d) {
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function openMega(d) {
    clearMegaTimers();
    if (d.hasAttribute('open')) return;
    document.querySelectorAll('details.mega-menu[open]').forEach(function (o) {
      if (o !== d) closeMega(o);
    });
    fitMega(d);
    d.setAttribute('open', '');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'true');
  }

  function closeAllMega() {
    document.querySelectorAll('details.mega-menu[open]').forEach(closeMega);
  }

  function anyMegaOpen() {
    return !!document.querySelector('details.mega-menu[open]');
  }

  function initPcMegaHover() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (hm) {
      if (hm.dataset.eqbMegaHoverBound) return;
      hm.dataset.eqbMegaHoverBound = '1';
      var details = hm.querySelector('details.mega-menu');
      if (!details) return;
      var summary = details.querySelector('summary');
      var content = details.querySelector('.mega-menu__content');

      hm.addEventListener('mouseenter', function () {
        if (!pcQuery.matches) return;
        clearTimeout(megaCloseTimer);
        if (details.hasAttribute('open')) return;
        clearTimeout(megaSwitchTimer);
        if (anyMegaOpen()) {
          megaSwitchTimer = setTimeout(function () { openMega(details); }, 150);
        } else {
          openMega(details);
        }
      });

      hm.addEventListener('mouseleave', function () {
        if (!pcQuery.matches) return;
        clearTimeout(megaSwitchTimer);
        if (!details.hasAttribute('open')) return;
        clearTimeout(megaCloseTimer);
        megaCloseTimer = setTimeout(function () { closeMega(details); }, 300);
      });

      if (content) {
        content.addEventListener('mouseenter', function () { clearMegaTimers(); });
      }
      if (summary) {
        summary.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
      }
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('details.mega-menu[open]').forEach(fitMega);
    });
  }

  function initPcMegaClose() {
    var targets = document.querySelectorAll('.header__inline-menu .list-menu--inline > li > a.header__menu-item, .header__icons .header__icon');
    targets.forEach(function (el) {
      if (el.dataset.eqbMegaCloseBound) return;
      el.dataset.eqbMegaCloseBound = '1';
      el.addEventListener('mouseenter', function () {
        if (!pcQuery.matches || !anyMegaOpen()) return;
        clearTimeout(megaCloseTimer);
        megaCloseTimer = setTimeout(closeAllMega, 250);
      });
    });
  }

  function init() {
    initMmobL2();
    initMmobL1();
    initPcMega();
    initPcMegaHover();
    initPcMegaClose();
    initCartA11y();
    initDrawerCol();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
